<template>
  <div class="case">
    <div  v-if="isScrolled9">
      <Header/>
    </div>
<div style="height: 5em;"></div>
    <!-- Breadcrumbs -->
    <div class="Breadcrumbs">
      <div class="box">
        <a href="index.html">首页</a> <span>></span> 网站地图
      </div>
    </div>

    <!-- blog -->
    <div class="wzmap">
      <div class="box">
        <h2 class="title">网站地图</h2>
        <div class="cont">
          <div class="item">
            <div class="tit"><a href="/">首页</a></div>
          </div>
          <div class="item">
            <div class="tit"><a href="/xingyeyingyong/">行业应用</a></div>
          </div>
          <div class="item">
            <div class="tit">关于我们</div>
            <div class="f-list">
            </div>
          </div>
          <div class="item">
            <div class="tit">技术介绍</div>
            <div class="f-list">
            </div>
          </div>
          <div class="item">
            <div class="tit"><a href="/price/">价格</a></div>
          </div>
          <div class="item">
            <div class="tit">新闻资讯</div>
            <div class="f-list">
              <a href="/companynews/">行业新闻 <img src="https://www.yasubit.com/template/pc/skin/images/righthuise.png"></a>
              <a href="/technologytrends/">技术动态 <img src="https://www.yasubit.com/template/pc/skin/images/righthuise.png"></a>
            </div>
          </div>
          <div class="item">
            <div class="tit">服务与支持</div>
            <div class="f-list">
              <a href="/privacy/">隐私条款 <img src="https://www.yasubit.com/template/pc/skin/images/righthuise.png"></a>
              <a href="/FAQ/">常见问题 <img src="https://www.yasubit.com/template/pc/skin/images/righthuise.png"></a>
              <a href="/contact/">联系我们 <img src="https://www.yasubit.com/template/pc/skin/images/righthuise.png"></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>

</template>
<script>
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header,
    Banner,
    Footer
  },
  data() {
    return {
      isScrolled9: true,
      newsStatus:false,
      newsStatus1:true,
      a:1111,
      data:[],
      data1:[],
      title:"",
      description:"",
      title2:"",
      description2:"",
      title3:"",
      description3:"",
      loading: true,
      caseList: []
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll9);
    window.console.log("case");
    this.$http
      .get("Cases/GetCasesAll")
      .then(response => {
        //console.log(response);
        this.caseList = response.data;
        //window.console.log(this.caseList);
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
    this.getData()
  },
  methods:{
    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
    news1(index){
if(index===1){
  this.newsStatus=true
  this.newsStatus1=false
}
      if(index===2){
        this.newsStatus1=true
        this.newsStatus=false
      }


    },

    detail(index){
      console.log(index)
      this.a=index
      sessionStorage.setItem('x', this.a);
      this.$router.push({
        name: 'text1', // 使用路由的 name 属性

        params: { a: this.a }
      });

    },
    detail2(index){
      console.log(index)
      this.a=index
      sessionStorage.setItem('x', this.a);
      this.$router.push({
        name: 'text2', // 使用路由的 name 属性
        params: { a: this.a }
      });

    },
    getData() {


      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/website/9', { headers })
          .then(response => {
            // 请求成功时更新数据
            console.log(8888);
            this.data = response.data;



            const data =this.data.data;
            // console.log(data[1].archiveList)
            // this.data=data[1].archiveList
            // this.data1=data[0].archiveList
            // console.log(data[1].archiveList)
            this.data=data[0].children[1].archiveList
            this.data1=data[0].children[0].archiveList
            console.log("babababb")
            console.log(this.data)
            console.log(this.data1)


          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });


    }


  }
};
</script>

 <style lang="scss" scoped>


 .between{

   display: flex;
   flex-direction: row;
   justify-content: space-between;
 }

 .center{
   display: flex;align-items: center; text-align: center;justify-content: center
 }
 .one-third{
   width: 33.333333%;
   height: 50px;
   background-color: pink;
 }
 .one-five{
   display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
   width: 20%;
   height: 50px;

 }



 .case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>